import { EInvoiceAddressSchemeType } from '../../../enums/eInvoiceAddressSchemeType'
import { EntityType } from '../../../enums/entityType'
import { EInvoiceScheme } from '../../../types/eInvoiceScheme'

export const getIsUnsupportedEInvoiceAddressType = (
  entityType: EntityType | undefined,
  schemeType: EInvoiceScheme,
): boolean => {
  return schemeType === EInvoiceAddressSchemeType.SIRENE && entityType === EntityType.Public
}
